import * as React from 'react';

import styles from './styles.module.scss';

interface OwnProps {
	material: {
		displayName: string;
		description: Nullable<string>;
		materialGroups: string[];
		vendor: Nullable<string>;
		vendorUniqueId: Nullable<string>;
	};
	className?: string;
}

type Props = OwnProps;

const MaterialEntry: React.FC<Props> = (props) => {
	const { material, className = '' } = props;
	const { displayName, description, materialGroups, vendor, vendorUniqueId } = material;

	const groups = materialGroups.join(', ');

	const resolvedClassName = `${styles.MaterialEntry} ${className}`;

	const descriptionStyle = `${styles.description} ${!description ? styles.missing : ''}`;

	const hasVendorLine = !!vendor || !!vendorUniqueId;

	return (
		<div className={resolvedClassName}>
			<div className={styles.nameAndGroups}>
				<div className={styles.name}>{displayName}</div>
				<div className={styles.groups}>{groups}</div>
			</div>
			<div className={descriptionStyle}>
				{description ? description : 'No description.'}
			</div>
			{hasVendorLine && (
				<div className={styles.vendorLine}>
					Vendor: {vendor ?? <span className={styles.notAssigned}>N/A</span>},&nbsp;
					Vendor ID: {vendorUniqueId ?? <span className={styles.notAssigned}>N/A</span>}
				</div>
			)}
		</div>
	);
};

export default React.memo(MaterialEntry);
